import Select, { SelectOption } from 'atoms/Select';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import OfferingSearch, { UserSearch } from 'molecules/OfferingSearch';
import React, { useCallback } from 'react';
import { useStore } from 'stores/store';
import { ISearch } from 'utils/networkRequests';
import { useUserTermUrlParam } from 'utils/query';

import s from './BrowsingHeader.module.scss';

const USER = 'user';
const OFFERING = 'offering';

const fieldOptions = [
  {
    value: OFFERING,
    name: 'Offering'
  },
  {
    value: USER,
    name: 'User'
  }
] as SelectOption[];

const HeaderSearch = ({
  defaultSearchTerm,
  defaultUserSearchTerm,
  showOfferingSearch,
  showUserSearch,
  onSelect,
  onSearch,
  requestCmd
}: {
  requestCmd?: string;
  defaultSearchTerm?: string;
  defaultUserSearchTerm?: string;
  showOfferingSearch?: boolean;
  showUserSearch?: boolean;
  onSelect?: (search?: ISearch) => void;
  onSearch?: (search?: ISearch) => void;
}) => {
  const store = useStore();
  const [searchField, setSearchField] = React.useState(showOfferingSearch ? OFFERING : USER);

  useUserTermUrlParam(
    useCallback((query) => {
      if (!query) return;
      setSearchField(USER);
    }, [])
  );

  const onSearchField = (value: string) => {
    setSearchField(value);
    store.MarketplaceStore.setOfferingSearchTerm('');
  };

  return (
    <div className={cn(s.BrowsingHeader__search)}>
      {showOfferingSearch && showUserSearch && (
        <Select
          className={s.BrowsingHeader__select}
          size="small"
          value={searchField}
          sx={{ width: '120px' }}
          displayEmpty
          onChange={(e) => onSearchField(e.target.value as string)}
          options={fieldOptions}
        />
      )}
      {searchField !== USER && (
        <OfferingSearch
          onSearch={onSearch}
          onSelect={onSelect}
          requestCmd={requestCmd}
          defaultSearchTerm={defaultSearchTerm}
        />
      )}
      {searchField === USER && (
        <UserSearch onSearch={onSearch} defaultSearchTerm={defaultUserSearchTerm} />
      )}
    </div>
  );
};

export default observer(HeaderSearch);
